/**
 * How much a kid's screens ask of them. "little" needs no reading (big pictures, one tap, read aloud),
 * "middle" is the standard kid experience, "older" adds numbers and leaves out the hand-holding.
 */
export const SCREEN_LEVELS = ["little", "middle", "older"] as const;
export type ScreenLevel = (typeof SCREEN_LEVELS)[number];

export const SCREEN_LEVEL_LABELS: Record<ScreenLevel, string> = {
  little: "Little: big pictures, read aloud",
  middle: "Growing: the standard screens",
  older: "Older: more numbers, fewer pictures",
};

const LITTLE_MAX_AGE = 6;
const MIDDLE_MAX_AGE = 10;

/** A parent's choice wins. Otherwise go by age; with no birth year, the standard screens. */
export function screenLevelFor(age: number | null, chosen: ScreenLevel | null = null): ScreenLevel {
  if (chosen) return chosen;
  if (age === null) return "middle";
  if (age <= LITTLE_MAX_AGE) return "little";
  return age <= MIDDLE_MAX_AGE ? "middle" : "older";
}
